import React from 'react';
import { connect } from 'react-redux';
import PromoCodeListConstructor from './PromoCodeListConstructor';
import { actions } from './PromoCodeListConstructor.actions';

const PromoCodeListConstructorComponent = connect(
    function mapStateToProps(state) {
        return {
            goalEntries: state.goalEntries.list,
            publisherId: state.user.publisher.id
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getDataLink: actions.getDataLink,
            deletePromoCode: actions.deletePromoCode
        };
    }
)(PromoCodeListConstructor);

export default PromoCodeListConstructorComponent;
